module.exports = __webpack_public_path__ + "img/logo-top.a0301963.png";